import React from 'react'
import DropDownSelection from './DropDownSelection'
import Mainsection from './Mainsection'
import Aboutsection from './Aboutsection'
import Cardsection from './Cardsection'
import Slidersection from './Slidersection'
import Relatedassetresources from './Relatedassetresources'
import FAQSection from './FAQSection'
import Footer from './Footersection/Footer'
import Header from './Header'

function Mainhomepage() {
  return (
    <>
    <Header/>
    <DropDownSelection/>
    <Mainsection/>
    <Aboutsection/>
    <Cardsection/>
    <Slidersection/>
    <Relatedassetresources/>
    <FAQSection/>
    <Footer/>
    </>
  )
}

export default Mainhomepage